import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal",
  id: "rule_config_modal",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = {
  class: "modal-body",
  id: "rule_config_modal_body"
}
const _hoisted_7 = {
  class: "alert alert-danger alert-dismissible show rule-error",
  role: "alert"
}
const _hoisted_8 = {
  class: "alert alert-warning alert-dismissible show rule-error",
  role: "alert"
}
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "form-group mb-3" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "form-group mb-3 triple-row" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = {
  id: "range",
  class: "form-control grey"
}
const _hoisted_18 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_19 = { class: "border p-1 mb-2" }
const _hoisted_20 = {
  key: 0,
  class: "list-group-flush p-0 mb-2"
}
const _hoisted_21 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_22 = { class: "badge badge-secondary parent-chip mr-2" }
const _hoisted_23 = { class: "input-group input-group-sm mr-2 kind-select" }
const _hoisted_24 = ["for"]
const _hoisted_25 = ["id", "onUpdate:modelValue"]
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "input-group input-group-sm mr-2 rule-select"
}
const _hoisted_28 = ["for"]
const _hoisted_29 = ["id", "onUpdate:modelValue"]
const _hoisted_30 = ["value"]
const _hoisted_31 = ["aria-label", "onClick"]
const _hoisted_32 = {
  key: 1,
  class: "text-muted small mb-2 pl-1"
}
const _hoisted_33 = {
  key: 1,
  class: "form-group mb-3"
}
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = {
  key: [null],
  value: [null]
}
const _hoisted_36 = {
  key: null,
  value: null
}
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "table" }
const _hoisted_39 = { scope: "row" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { class: "d-flex align-items-center mb-1" }
const _hoisted_42 = {
  class: "icon-container d-inline-block ml-2",
  title: "Filters which sensors this rule considers. Entries within one block are AND (a sensor must carry every tag=value pair). Adding an 'OR' condition broadens the filter — a sensor matches if any of the AND-groups matches."
}
const _hoisted_43 = { class: "form-group mb-3 row" }
const _hoisted_44 = { class: "input-group col" }
const _hoisted_45 = { class: "input-group col" }
const _hoisted_46 = { class: "form-group mb-3" }
const _hoisted_47 = { class: "input-group" }
const _hoisted_48 = { class: "form-group form-check" }
const _hoisted_49 = { class: "form-group form-check" }
const _hoisted_50 = { class: "form-group form-check" }
const _hoisted_51 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_JoinConfigSection = _resolveComponent("JoinConfigSection")!
  const _component_TagMultiPicker = _resolveComponent("TagMultiPicker")!
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, "Configure " + _toDisplayString(_ctx.Name), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedRule && _ctx.clearSelectedRule(...args)))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Error:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.errorMessage) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "alert",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorMessage = ''))
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ], 512), [
            [_vShow, _ctx.errorMessage]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Saved with warnings:", -1)),
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warnings, (w, i) => {
                return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(w), 1))
              }), 128))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "alert",
              "aria-label": "Close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.warnings = []))
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ], 512), [
            [_vShow, _ctx.warnings.length > 0]
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "input-group-text" }, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "text",
                  id: "desc",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.Name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "input-group-text" }, "Task", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "range",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.TaskID) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => {
                    _ctx.sourceData = _ctx.getPropertyForTask(_ctx.TaskID, 'InputTable');
                    _ctx.updateParameterOptions(_ctx.TaskID);
                    _ctx.joinExtras = {};
                  })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: task.TaskID,
                      value: task.TaskID
                    }, _toDisplayString(task.Name), 9, _hoisted_14))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.TaskID]
                ])
              ]),
              _createElementVNode("div", {
                class: "icon-container",
                title: _ctx.getPropertyForTask(_ctx.TaskID, 'Documentation')
              }, [
                _createVNode(_component_vue_feather, { type: "info" })
              ], 8, _hoisted_15),
              _createElementVNode("div", _hoisted_16, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "input-group-text" }, "Data", -1)),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.sourceData), 1)
              ])
            ]),
            (_ctx.isJoinRule)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "input-group-text mb-1" }, "Parent Sources", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.parents.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parents, (parent, idx) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: parent.id,
                              class: "list-group-item p-1"
                            }, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, "P" + _toDisplayString(parent.id), 1),
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("label", {
                                    class: "input-group-text",
                                    for: `parent-kind-${parent.id}`,
                                    title: "Type of parent source"
                                  }, " Kind ", 8, _hoisted_24),
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-control",
                                    id: `parent-kind-${parent.id}`,
                                    "onUpdate:modelValue": ($event: any) => ((parent.kind) = $event)
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parentKindOptions, (k) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: k,
                                        value: k
                                      }, _toDisplayString(k), 9, _hoisted_26))
                                    }), 128))
                                  ], 8, _hoisted_25), [
                                    [_vModelSelect, parent.kind]
                                  ])
                                ]),
                                (parent.kind === 'task_rule')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("label", {
                                        class: "input-group-text",
                                        for: `parent-rule-${parent.id}`,
                                        title: "Which parent task rule this entry references"
                                      }, " Rule ", 8, _hoisted_28),
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-control",
                                        id: `parent-rule-${parent.id}`,
                                        "onUpdate:modelValue": ($event: any) => ((parent.task_rule_id) = $event)
                                      }, [
                                        _cache[25] || (_cache[25] = _createElementVNode("option", { value: null }, "— Select a rule —", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTaskRulesFor(parent), (rule) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: rule.TaskRuleID,
                                            value: rule.TaskRuleID
                                          }, _toDisplayString(rule.Name), 9, _hoisted_30))
                                        }), 128))
                                      ], 8, _hoisted_29), [
                                        [_vModelSelect, parent.task_rule_id]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  class: "btn btn-sm btn-outline-danger ml-auto mt-1",
                                  type: "button",
                                  "aria-label": `Remove parent P${parent.id}`,
                                  onClick: ($event: any) => (_ctx.removeParent(idx))
                                }, [
                                  _createVNode(_component_vue_feather, {
                                    type: "trash",
                                    size: "14"
                                  })
                                ], 8, _hoisted_31)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_32, " No parent sources yet. Add one below to start building the join. ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-success",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addParent && _ctx.addParent(...args)))
                    }, [
                      _createVNode(_component_vue_feather, {
                        type: "plus",
                        size: "14"
                      }),
                      _cache[26] || (_cache[26] = _createTextVNode(" Add parent ", -1))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "input-group-text" }, "Input Data Source", -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "range",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.DataTaskRuleIDs) = $event))
                    }, [
                      (_openBlock(), _createElementBlock("option", _hoisted_35, "Raw Data")),
                      (_openBlock(), _createElementBlock("option", _hoisted_36, "All Data")),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task_rules, (taskRule) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: taskRule.TaskRuleID,
                          value: [taskRule.TaskRuleID]
                        }, _toDisplayString(taskRule.Name), 9, _hoisted_37))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.DataTaskRuleIDs]
                    ])
                  ])
                ])),
            (_ctx.isJoinRule)
              ? (_openBlock(), _createBlock(_component_JoinConfigSection, {
                  key: 2,
                  parents: _ctx.parents,
                  "join-config": _ctx.joinConfig,
                  "tag-sets": _ctx.tagSets,
                  "sensor-tag-options": _ctx.sensorTagOptions,
                  "task-rules": _ctx.task_rules
                }, null, 8, ["parents", "join-config", "tag-sets", "sensor-tag-options", "task-rules"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text h5" }, "Parameters", -1)),
              _createElementVNode("table", _hoisted_38, [
                _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "Parameter"),
                    _createElementVNode("th", { scope: "col" }, "Value")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (value, key) => {
                    return (_openBlock(), _createElementBlock("tr", { key: key }, [
                      _createElementVNode("th", _hoisted_39, _toDisplayString(key), 1),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(`form-control ${_ctx.isValidJSON(_ctx.parameters[key]) ? '' : 'is-invalid'}`),
                          type: "text",
                          id: "desc",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.parameters[key]) = $event)
                        }, null, 10, _hoisted_40), [
                          [_vModelText, _ctx.parameters[key]]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ], 512), [
              [_vShow, _ctx.parameters && Object.entries(_ctx.parameters).length]
            ]),
            (!_ctx.isJoinRule)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text h5 mb-0" }, "Sensor Tags", -1)),
                    _createElementVNode("span", _hoisted_42, [
                      _createVNode(_component_vue_feather, {
                        type: "info",
                        size: "16"
                      })
                    ])
                  ]),
                  _createVNode(_component_TagMultiPicker, {
                    "tag-sets": _ctx.tagSets,
                    "sensor-tag-options": _ctx.sensorTagOptions,
                    "aria-context": "from sensor tags",
                    class: "mb-3"
                  }, null, 8, ["tag-sets", "sensor-tag-options"])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "input-group-text" }, "Start", -1)),
                _createVNode(_component_datepicker, {
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "form-control",
                  style: {"width":"158px","border-top-left-radius":"0","border-bottom-left-radius":"0"},
                  modelValue: _ctx.pickerStartDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pickerStartDate) = $event)),
                  onfocusout: _ctx.push_end_date(),
                  minimumView: "time"
                }, null, 8, ["inputFormat", "modelValue", "onfocusout"])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "input-group-text" }, "End", -1)),
                _createVNode(_component_datepicker, {
                  typeable: "",
                  inputFormat: _ctx.dateFormat,
                  class: "form-control",
                  style: {"width":"167px","border-top-left-radius":"0","border-bottom-left-radius":"0"},
                  disabled: !_ctx.endDate,
                  modelValue: _ctx.pickerEndDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pickerEndDate) = $event)),
                  "lower-limit": _ctx.pickerStartDate,
                  minimumView: "time"
                }, null, 8, ["inputFormat", "disabled", "modelValue", "lower-limit"])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "input-group-text" }, "Max Concurrent", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "number",
                  min: "1",
                  placeholder: "Unlimited",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.maxConcurrent) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.maxConcurrent]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.enabled]
              ]),
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-check-label" }, "Enabled?", -1))
            ]),
            _createElementVNode("div", _hoisted_49, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endDate) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.endDate]
              ]),
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-check-label" }, "End Date?", -1))
            ]),
            _createElementVNode("div", _hoisted_50, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.multipleTruePerBatch) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.multipleTruePerBatch]
              ]),
              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-check-label" }, "Multiple per batch?", -1))
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-dismiss": "modal",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedRule && _ctx.clearSelectedRule(...args)))
          }, "Close"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.save_rule && _ctx.save_rule(...args)))
          }, "Save changes")
        ])
      ])
    ])
  ]))
}